import { render, staticRenderFns } from "./CampaignPerformance.vue?vue&type=template&id=6fba758f&scoped=true"
import script from "./CampaignPerformance.vue?vue&type=script&lang=js"
export * from "./CampaignPerformance.vue?vue&type=script&lang=js"
import style0 from "./CampaignPerformance.vue?vue&type=style&index=0&id=6fba758f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fba758f",
  null
  
)

export default component.exports